<template>
    <div class="d-flex align-items-center">
        <button class="btn btn-sm btn-light" type="button" @click="showModal()">
            View old
        </button>
        <i class="mx-2 bi-chevron-right"/>
        <button class="btn btn-sm btn-light" type="button" @click="showModal(true)">
            View new
        </button>
    </div>
</template>

<script>
export default {
    name: "ItemHistoryChangeTypeTexteditor",
    props: {
        oldValue: String,
        newValue: String,
        label: String,
    },
    methods: {
        showModal(viewNew) {
            this.$store.dispatch('modals/show', {
                componentName: 'HistoryTexteditorModal',
                obj: {
                    value: viewNew ? this.newValue : this.oldValue,
                    label: this.label
                }
            })
        }
    }
}
</script>

<style scoped>

</style>